import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

export const contentElementAnimations = async (err) => {
  if (err) {
    console.error(err);
  }

  /*
  /* div Elements Animations on scroll
  */
  reveal();
  function reveal() {
    var reveals = document.querySelectorAll('.reveal');

    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = reveals[i].getBoundingClientRect().top;
      var elementVisible = 10;

      var delay = 100;
      if (reveals[i].classList.contains('delay-1000')) {
        delay = 1000;
      }
      if (reveals[i].classList.contains('delay-500')) {
        delay = 500;
      }
      if (reveals[i].classList.contains('delay-200')) {
        delay = 200;
      }

      if (elementTop < windowHeight - elementVisible) {
        let that = reveals[i];
        setTimeout(() => {
          that.classList.add('active');
        }, delay);
      } /*  else {
        reveals[i].classList.remove("active");
      } */
    }
  }
  window.addEventListener('scroll', reveal);

  /*
   * Start animation for content element curly arrow on scroll
   */
  const curlyArrow = document.querySelector('.gm-curly-arrow');
  const curlyArrowObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          //console.log('curly-arrow is visible');
          curlyArrow.classList.add('is-visible');
        } else {
          //console.log('curly-arrow is not visible');
          //curlyArrow.classList.remove('is-visible');
        }
      });
    },
    {threshold: 0.2},
  );

  if (curlyArrow) {
    curlyArrowObserver.observe(curlyArrow);
  }
  // Start animation for content element zigzag line on scroll
  const zigzagLinie = document.querySelector('.zigzag-linie');

  const zigzagLinieObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          zigzagLinie.classList.add('is-visible');
        } else {
          //console.log('zigzag-linie is not visible');
        }
      });
    },
    {threshold: 0.3},
  );

  if (zigzagLinie) {
    zigzagLinieObserver.observe(zigzagLinie);
  }

  const animatedElements = document.querySelectorAll('.scroll-animate');
  animatedElements.forEach(function (el) {
    let io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.classList.add('is-visible');
          }
        });
      },
      {threshold: 0.3},
    );

    if (io) {
      io.observe(el);
    }
    /*
     *  Observer für animierte Elemente die ohne scrollen sofort im Viewport sind, um die Animation zu verzögern
     */
    const observerOptions = {
      root: null, // nutzt den Viewport des Browsers
      threshold: 0.15, // triggert, sobald 15% des Elements sichtbar sind
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const element = entry.target;

          // PRÜFUNG: Ist der User noch ganz oben und das Element wird sofort geladen?
          const isAtTop = window.scrollY < 50;

          if (isAtTop && element.classList.contains('is-visible')) {
            // Element ist sofort im Viewport -> Delay-Klasse hinzufügen
            element.classList.add('loaded-in-viewport');
          }

          // Standard-Klasse für die Animation hinzufügen
          element.classList.add('is-visible');

          // Sobald animiert, Observer für dieses Element stoppen
          observer.unobserve(element);
        }
      });
    }, observerOptions);

    animatedElements.forEach((el) => observer.observe(el));
  });

  /*
   * Start animation for content element accordion on scroll
   */

  const accordions = document.querySelectorAll('.wp-block-accordion-item');

  const setPanelHeight = (item) => {
    const panel = item.querySelector('.wp-block-accordion-panel');
    if (!panel) return;
    panel.style.setProperty('--panel-h', `${panel.scrollHeight}px`);
  };

  accordions.forEach((item) => {
    setPanelHeight(item);

    // Recalculate when content changes (images, async content, etc.)
    const panel = item.querySelector('.wp-block-accordion-panel');
    if (!panel) return;

    const ro = new ResizeObserver(() => setPanelHeight(item));
    ro.observe(panel);
  });

  window.addEventListener('resize', () => {
    accordions.forEach(setPanelHeight);
  });

  /*
  /* Team mood images section animation on scroll
  */
  gsap.registerPlugin(ScrollTrigger);

  window.addEventListener('load', () => {
    const triggerElement = document.querySelector('.team-mood-images-section');
    const images = document.querySelectorAll(
      '.team-mood-images-section__images-container .wp-block-image',
    );

    if (!triggerElement || images.length === 0) return;

    // Initiale Rotation und Skalierung der Bilder in der Mitte
    gsap.set(images, {
      xPercent: -50,
      yPercent: -50,
      opacity: 0,
      scale: 0.8,
      rotation: () => gsap.utils.random(-5, 5),
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: triggerElement,
        start: 'top top', // Dockt perfekt an, sobald die Oberkante erreicht ist
        end: '+=180%', // Scroll-Distanz
        scrub: 1, // Weicher Nachlauf
        pin: true, // Fixiert die Sektion
        pinSpacing: true, // Schiebt den Rest der Seite sauber nach unten
        anticipatePin: 1, // Verhindert Ruckler beim Start des Pins
        pinType: 'fixed', // Zitterfreies Rendern des Browsers nutzen
        invalidateOnRefresh: true,
      },
    });

    // Die Flugbahnen nach aussen
    const paths = [
      {x: '-190%', y: '-110%', rot: -15},
      {x: '190%', y: '-120%', rot: 12},
      {x: '-200%', y: '90%', rot: -10},
      {x: '200%', y: '100%', rot: 18},
    ];

    images.forEach((img, index) => {
      const path = paths[index % paths.length];

      // 1. Sanftes Einblenden
      tl.to(
        img,
        {
          opacity: 1,
          scale: 1,
          duration: 0.3,
          ease: 'power1.inOut',
        },
        0,
      )

        // 2. Weites Auseinanderfliegen
        .to(
          img,
          {
            xPercent: parseFloat(path.x),
            yPercent: parseFloat(path.y),
            rotation: path.rot,
            duration: 1,
            ease: 'power1.out',
          },
          0,
        )

        // 3. Ausblenden kurz vor Ende des Pins
        .to(
          img,
          {
            opacity: 0,
            scale: 0.7,
            duration: 0.4,
            ease: 'power1.in',
          },
          0.6,
        ); // Startet das Ausfaden bei 60% des Weges
    });
  });
};

import.meta.webpackHot?.accept(contentElementAnimations);
